import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ParticipationPortalService {
    private http = inject(HttpClient);

    requestAccess() {
        return this.http.post('/participation-portal/access-request', null);
    }
}
